/**
 * TrazaSaber — GEN-PX-016: pestaña «Saber» de Auditoría. Lo que ha cambiado en áreas, KBs, iKus, etiquetas y lo que hace
 * Jimmy por encargo (GET /v1/ekb/traza). Antes vivía al pie de la pantalla de KBs. Solo lectura; la puerta es del kernel
 * (administrador y Champion), aquí no se decide nada.
 */
import { useEffect, useState } from 'react'
import { getTrazaEkb, listKbs } from '../api/client.js'
import { lineaTraza, quienTraza } from '../lib/trazaEkb.js'

export default function TrazaSaber() {
  const [traza, setTraza] = useState(null) // null cargando | [] | [...]
  const [nombres, setNombres] = useState({})
  const [error, setError] = useState(false)

  useEffect(() => {
    let vivo = true
    getTrazaEkb().then(r => vivo && setTraza(r.traza ?? [])).catch(() => vivo && setError(true))
    // Nombres de KB para apuntes antiguos que no los traen; si falla, la línea sale sin nombre.
    listKbs('todos')
      .then(r => vivo && setNombres(Object.fromEntries((r?.kbs ?? []).map(k => [k.id, k.nombre]))))
      .catch(() => {})
    return () => { vivo = false }
  }, [])

  return (
    <section className="mec-visor" aria-label="Traza de Saber">
      <h2>Saber</h2>
      {error && <p className="equipo-estado" role="alert">No se ha podido cargar la traza.</p>}
      {!error && traza === null && <p className="equipo-estado">Cargando…</p>}
      {traza?.length === 0 && <p className="equipo-estado">Sin movimientos todavía.</p>}
      {traza?.length > 0 && (
        <ul className="kbs-traza" aria-label="Traza de Saber">
          {traza.map(t => (
            <li key={t.id}>
              {new Date(t.ts).toLocaleString()} · <strong>{lineaTraza(t, id => nombres[id])}</strong> · {quienTraza(t)}
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
